/* eslint-disable */
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../tfa-auth/contexts/authContext';
import { DrawerHeader, drawerWidth, Main } from './styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';

import { Header } from './components/Header/Header';
import logo from '../../assets/icons/logo.svg';
import { SideItem } from './components/SideItem/SideItem';
import adminApi from '../../apis/AdminApi';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { Pages } from '../../constants/Pages';
import { UserRoles } from '../../types/User';
import { useUserRole } from '../../hooks/useUserRole';

type HeaderProps = {
  hasHeader: boolean;
  hasAvatar: boolean;
  hasSearch: boolean;
  hasIcon?: boolean;
  hasBurger: boolean;
  hasMail: boolean;
  hasNotification: boolean;
};

export const Layout: React.FC<HeaderProps> = (props) => {
  const authContext = React.useContext(AuthContext);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userRole } = useUserRole();
  const { user } = useAppSelector((state) => state.model);

  const [openSide, setOpenSide] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpenSide(!openSide);
  };

  // @ts-ignore
  return (
    <Box style={{ display: 'flex' }}>
      <CssBaseline />
      {props.hasHeader ? (
        <Header
          handleDrawerOpen={handleDrawerOpen}
          openSide={openSide}
          hasAvatar={props.hasAvatar}
          hasBurger={props.hasBurger}
          hasMail={props.hasMail}
          hasNotification={props.hasNotification}
          hasSearch={props.hasSearch}
        />
      ) : null}
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            background: '#0CBDD4',
          },
        }}
        variant='persistent'
        anchor='left'
        open={props.hasHeader ? openSide : true}
      >
        <DrawerHeader style={{ marginBottom: 24, marginTop: 8 }}>
          <img src={logo} alt='GaleAI Logo' onClick={() => navigate(`/`)} />
        </DrawerHeader>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <List
            style={{
              height: 'auto',
              flex: 1,
            }}
          >
            <SideItem
              text='Results'
              icon={<DescriptionOutlinedIcon />}
              active={window.location.pathname.includes(Pages.results)}
              onClick={() => {
                navigate(Pages.results);
              }}
            />
            {(userRole === UserRoles.SUPER_ADMIN ||
              userRole === UserRoles.ORG_OWNER) && (
              <SideItem
                text='Users'
                icon={<PersonOutlineIcon />}
                active={window.location.pathname.includes(Pages.users)}
                onClick={() => {
                  navigate(Pages.users);
                }}
              />
            )}
            {userRole === UserRoles.SUPER_ADMIN && (
              <SideItem
                text={'Organizations'}
                icon={<BusinessCenterOutlinedIcon />}
                active={window.location.pathname.includes(Pages.organizations)}
                onClick={() => navigate(Pages.organizations)}
              />
            )}
            {userRole === UserRoles.ORG_OWNER && (
              <SideItem
                text={'Organization'}
                icon={<BusinessCenterOutlinedIcon />}
                active={window.location.pathname.includes(Pages.organizations)}
                onClick={() =>
                  navigate(
                    Pages.getRoute(
                      Pages.editOrganization,
                      user?.organizationId ?? ''
                    )
                  )
                }
              />
            )}
            {userRole === UserRoles.SUPER_ADMIN && (
              <>
                <SideItem
                  text={'AI Playground'}
                  icon={<SmartToyOutlinedIcon />}
                  active={window.location.pathname.includes(Pages.AIplayground)}
                  onClick={() => navigate(Pages.AIplayground)}
                />
                <SideItem
                  text={'Fee Schedules (Athena)'}
                  icon={<AttachMoneyOutlinedIcon />}
                  active={window.location.pathname.includes(Pages.FeeSchedules)}
                  onClick={() => navigate(Pages.FeeSchedules)}
                />
              </>
            )}
          </List>
          <List
            style={{
              height: 'auto',
              marginBottom: 48,
            }}
          >
            <SideItem
              text='Switch to app'
              active={false}
              icon={<SyncAltOutlinedIcon />}
              onClick={() => {
                window.location.assign('https://webapp.galeai.co/home');
              }}
            />
            <SideItem
              text='Log out'
              active={false}
              icon={<PowerSettingsNewIcon />}
              onClick={async () => {
                await authContext.signOut();
                dispatch(adminApi.util.resetApiState());
                localStorage.clear();
              }}
            />
          </List>
        </Box>
      </Drawer>
      <Main open={props.hasHeader ? openSide : true}>
        {props.hasHeader ? <DrawerHeader /> : null}
        {props.children}
      </Main>
    </Box>
  );
};
